import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import '../styles/team.css'
import Testimonials from './Testimonials'
import TeamsDisplay from './TeamsDisplay'
import TeamList from './TeamList'
import { IoClose } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { teamDataMap } from '../jsonfiles/teamDataMap'
import { Testimonials25 } from '../jsonfiles/Testimonials25-26'

/* Team Landing Page
  Update - 37, 212 
*/

function Team({ props }) {
  const { yearContent } = props;

  const { CoreTeam, TeamHeads, Volunteers } = yearContent.data[0];

  const navigate = useNavigate();

  // Get image path
  function getImagePath(currEle) {
    return currEle && Object.keys(currEle).length > 0
      ? require(`../imagProps/team25/${currEle.imgPath}`)
      : null;
  }

  const [modalIsOpen, setIsOpen] = useState(false);
  const [currEle, setCurrEle] = useState({});

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState(() => {
    // Retrieve selected year from localStorage or fallback to current one
    return localStorage.getItem('selectedYear') || "2025-26";
  });

  // Custom scrollbar styles
  useEffect(() => {
    // Add custom scrollbar styles
    const style = document.createElement('style');
    style.innerHTML = `
      .custom-scrollbar::-webkit-scrollbar {
        width: 5px;
      }
      .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #90caf9;
        border-radius: 10px;
      }
      .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #1e88e5;
      }
      .custom-scrollbar {
        scrollbar-width: thin;
        scrollbar-color: #90caf9 #f1f1f1;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // On change of year, save and navigate
  useEffect(() => {
    localStorage.setItem('selectedYear', selectedYear);
    const teamPath = teamDataMap[selectedYear]?.teamPath;

    // Only navigate if it's a different path than current
    if (teamPath && teamPath !== yearContent.teamPath) {
      navigate(`/${teamPath}`);
    }
  }, [selectedYear, navigate, yearContent.teamPath]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (isDropdownOpen && !event.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Modal control
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function handleYearChange(year) {
    setSelectedYear(year);
    setIsDropdownOpen(false);
  }

  return (
    <div id="teamm">
      <br />
      <br />
      <br />
      {/* Custom dropdown with proper positioning */}
      <div className="flex justify-center items-center mb-32 relative dropdown-container">
        <div className="relative w-full max-w-xs">
          <button
            className="w-full text-center font-semibold text-blue-600 bg-white py-3 px-4 rounded-xl shadow-lg focus:outline-none focus:ring-4 focus:ring-blue-200 cursor-pointer transition-all"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {`Team (${selectedYear})`}
            <span className="absolute top-1/2 right-4 transform -translate-y-1/2 text-blue-600">
              <svg
                className={`w-5 h-5 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </span>
          </button>

          {isDropdownOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl z-50 h-20 overflow-y-auto custom-scrollbar">
              {Object.keys(teamDataMap).map((yearKey) => (
                <div
                  key={yearKey}
                  className={`py-2 px-4 cursor-pointer hover:bg-blue-50 transition-colors ${selectedYear === yearKey ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-blue-600'
                    }`}
                  onClick={() => handleYearChange(yearKey)}
                >
                  {`Team (${yearKey})`}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Core Team Section */}
      <div className='teamlist'>
        <div className='title'>
          <h1>{selectedYear === "2018-2019" ? "Committee Members" : "Core Team"}</h1>
        </div>
        <div className='teamgrid'>
          <TeamList teamArray={CoreTeam} teamPath={yearContent.teamPath} />
        </div>
      </div>

      {/* Team Heads Section */}
      {Array.isArray(TeamHeads) && TeamHeads.length > 0 && (
        <div className='teamlist'>
          <div className='title'>
            <h1>Team Heads</h1>
          </div>
          <div className='teamgrid'>
            <TeamList teamArray={TeamHeads} teamPath={yearContent.teamPath} />
          </div>
        </div>
      )}

      {/* Volunteers Table */}
      <div className='table'>
        <div className='table__header'>
          <h1>Volunteers</h1>
        </div>
        <div className='table__body'>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Team</th>
                <th>Mail ID</th>
              </tr>
            </thead>
            <tbody>
              {Volunteers.map((item, ind) => (
                <tr key={ind}>
                  <td>
                    <div className='named'>
                      <a href={item.linkedin} target='_blank' rel="noopener noreferrer">
                        {item.Name}
                      </a>
                    </div>
                  </td>
                  <td>{item.Team}</td>
                  <td><a href={`mailto:${item.Mail}`}>{item.Mail}</a></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <TeamsDisplay />


      {/* Testimonials Section */}
      <div className='text-stone-50 pt-[65px] pb-[30px]'>
        <Testimonials
          testimonials={Testimonials25}
          yearPath="team25"
          openModal={openModal}
          modalIsOpen={modalIsOpen}
          setIsOpen={setIsOpen}
          currEle={currEle}
          setCurrEle={setCurrEle}
        />
      </div>

      {/* Modal for Testimonials */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -60%)',
            backgroundColor: 'white',
            zIndex: 999,
            maxWidth: '70%',
            maxHeight: '80vh',
            overflowY: 'auto',
            marginTop: '10vh',
          },
          overlay: {
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998,
          }
        }}
      >
        <div className='modal-content'>
          <div>
            <button className='close-button' onClick={closeModal}><IoClose /></button>
          </div>
          <div>
            <p>"{currEle.Content}"</p>
          </div>
          <div className='author'>
            <div className='author-img'>
              {getImagePath(currEle) && <img src={getImagePath(currEle)} alt="sq-sample1" loading="lazy" decoding="async" />}
            </div>
            <div className='author-desc'>
              <p style={{ fontWeight: '600' }}>{currEle.Name}</p>
              <p>{currEle.Desig}</p>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Team;